<template lang="pug">
form#manage-budget-form
  fieldset
    BudgetsForm(
      :organization="organization"
      :duration-format="durationFormat"
      :disabled="!canManageBudget"
      :budget-state="budgetState"
      :has-budget="!!client.has_budget"
      @change-budget-field="handleChangeBudgetField"
      @clear-budget="handleClearBudget"
    )
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import BudgetsForm from '../budgets/BudgetsForm.vue';

export default {
  name: 'ClientDialogTabBudgets',
  components: { BudgetsForm },
  computed: {
    ...mapState(['client', 'budget', 'organization']),
    ...mapGetters(['durationFormat', 'canManageBudget']),
    budgetState() {
      return this.client.budget || {};
    },
  },
  methods: {
    ...mapActions(['updateField', 'resetBudget']),
    handleClearBudget() {
      this.resetBudget();
      this.$emit('clearedBudget');
    },
    handleChangeBudgetField(field, val) {
      this.updateField({ path: `budget.${field}`, value: val });
    },
  },
};
</script>
